import App from './App-compose';

export default App;
